import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../../Assets/CSS/Styles.scss";
export default function NewsDetail() {
  const { id } = useParams();
  const [newsArticle, setNewsArticle] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`http://localhost:8000/api/blogs/${id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to load news");
        }
        return res.json();
      })
      .then((data) => setNewsArticle(data))
      .catch((err) => setError(err.message));
  }, [id]);

  if (error) {
    return <div className="text-center text-red-500 mt-10">{error}</div>;
  }

  if (!newsArticle) {
    return <div className="text-center text-gray-500 mt-10">Loading...</div>;
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-8 mt60">
      {/* Image */}
      {newsArticle.image && (
        <img
          src={`http://localhost:8000/uploads/${newsArticle.image}`}
          alt={newsArticle.title}
          className="w-full h-96 object-cover rounded-lg shadow-md"
        />
      )}

      {/* Title */}
      <h1 className="text-4xl font-bold mt-6 mb-2">{newsArticle.title}</h1>

      {/* Date + Author */}
      <div className="flex items-center gap-4 text-gray-500 mb-6">
        <span>{new Date(newsArticle.publishDate).toLocaleDateString()}</span>
        <span>•</span>
        <span>{newsArticle.author || "Unknown Author"}</span>
      </div>

      {/* Overview */}
      {newsArticle.overview && (
        <p className="text-lg text-gray-700 mb-8">{newsArticle.overview}</p>
      )}

      {/* Full Sections */}
      {newsArticle.sections?.length > 0 && (
        <div className="space-y-8">
          {newsArticle.sections.map((section, index) => (
            <div key={index} className="border-b pb-6">
              {section.title && (
                <h2 className="text-2xl font-semibold mb-3">{section.title}</h2>
              )}
              {section.description && (
                <p className="text-gray-700 mb-4">{section.description}</p>
              )}
              {section.points && section.points.length > 0 && (
                <ul className="list-disc list-inside space-y-1 text-gray-700">
                  {section.points.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
